module.exports = __webpack_public_path__ + "img/ume_right_logo.4cdfd99b.png";